import PropTypes from 'prop-types'
import React from 'react'
import { Control } from 'react-redux-form'
import { Radio, RadioGroup } from 'components/styled/radio'
import { validators } from 'utils/form'
import { useStore } from 'react-redux'

const { isRequired } = validators

const propTypes = {
  field: PropTypes.shape({
    _id: PropTypes.string.isRequired,
    fieldSetup: PropTypes.shape({ required: PropTypes.bool }).isRequired,
    options: PropTypes.arrayOf(
      PropTypes.shape({
        value: PropTypes.string,
      })
    ),
  }).isRequired,
  noValidation: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  fieldResponse: PropTypes.shape({
    answer: PropTypes.oneOfType([
      PropTypes.arrayOf(PropTypes.string),
      PropTypes.string,
    ]),
  }),
}

const defaultProps = {
  fieldResponse: undefined,
}

const groupPropTypes = {
  componentProps: PropTypes.shape({
    field: PropTypes.shape({
      _id: PropTypes.string.isRequired,
      fieldSetup: PropTypes.shape({ required: PropTypes.bool }).isRequired,
      options: PropTypes.arrayOf(
        PropTypes.shape({
          value: PropTypes.string,
        })
      ),
    }).isRequired,
    fieldResponse: PropTypes.shape({
      answer: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.string),
        PropTypes.string,
      ]),
    }),
  }).isRequired,
  onChange: PropTypes.func.isRequired,
}

const RadioGroupComponent = ({ componentProps, onChange }) => {
  const { field, fieldResponse } = componentProps
  return (
    <RadioGroup useGrid>
      {field.options.map(option => (
        <Radio
          key={`${field._id}-${option.value}`}
          label={option.label}
          id={`${field._id}-${option.value}`}
          value={option.value}
          onChange={() => onChange(option.value)}
          isSelected={
            fieldResponse &&
            fieldResponse.answer &&
            fieldResponse.answer === option.value
          }
        />
      ))}
    </RadioGroup>
  )
}

RadioGroupComponent.propTypes = groupPropTypes

export function RadioField({ field, noValidation, onChange, fieldResponse }) {
  const store = useStore()
  return (
    <div id={field._id}>
      <Control
        store={store}
        model={`.${field._id}`}
        validators={
          field.fieldSetup.required && !noValidation ? { isRequired } : null
        }
        component={RadioGroupComponent}
        onChange={value => onChange(value)}
        componentProps={{ field, fieldResponse }}
      />
    </div>
  )
}

RadioField.propTypes = propTypes
RadioField.defaultProps = defaultProps

export default RadioField
